import { Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSignaturePadComponent } from '@mr-samani/ngx-signature-pad';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppConst, APP_CONSTANT } from 'src/app/core/_constants/app.constant';
import { UploadService } from 'src/app/core/_services/upload.service';

@Component({
  selector: 'app-collect-signature',
  templateUrl: './collect-signature.component.html',
  styleUrls: ['./collect-signature.component.scss']
})
export class CollectSignatureComponent implements OnInit {
  @ViewChild('signaturePad') signaturePad: any; 
  @ViewChild('signaturePad2') signaturePad2: any; 
 
  open: any;
  uploadedFiles: any;
  imageUrl: any;
  // imageInvalidMsg: any;
  // imageInvalid: boolean = false;
  signature: string = '';
  isSignatureNotAdded: boolean = true;

  constructor(public dialogRef: MatDialogRef<CollectSignatureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loader: NgxUiLoaderService,
    private toastr: ToastrService,
    private upload: UploadService
  ) { }

  ngOnInit(): void {
  }
  reset() {
    this.imageUrl = ''
  }
  approveSignature() {
    if (this.imageUrl != '' && this.imageUrl != null && this.imageUrl != undefined) {
      this.dialogRef.close(this.imageUrl);
    }
    else {
      // this.imageInvalidMsg =  APP_CONSTANT.VALIDATION.signature;
    }
  }
  async fileupload(e: any) {
    const selectedFile = e;
    if (e) {
    this.loader.start();

      if ((selectedFile.type.match(/png/) == null)) {
        // this.imageInvalidMsg = APP_CONSTANT.VALIDATION.imageExt;
        // this.imageInvalid = true;
        this.loader.stop();
        return false;
      }
      let uploadedImage: any = await this.upload.uploadFile(selectedFile);
      if (uploadedImage) {
        this.imageUrl = uploadedImage;
        // this.imageInvalidMsg = "";
        // this.imageInvalid = false;
        this.loader.stop();
        this.approveSignature();
        return true;
      } else {
        this.loader.stop();
        this.toastr.error(`${AppConst.ERROR_MESSAGES.SERVER_ERROR}`)
        return false;
      }
    }
    this.loader.stop()
    return false;

  }

  getSignature(ev: string) {
    if(window.innerWidth > 767){
      this.isSignatureNotAdded = this.isCanvasBlank(this.signaturePad.ctx)
    }
    else{
      this.isSignatureNotAdded = this.isCanvasBlank(this.signaturePad2.ctx)
    }
  }

  clear(pad: NgxSignaturePadComponent) {
    pad.clearSignaturePad();
    if(window.innerWidth > 768){
      this.isSignatureNotAdded = this.isCanvasBlank(this.signaturePad.ctx)
    }
    else{
      this.isSignatureNotAdded = this.isCanvasBlank(this.signaturePad2.ctx)
    }
    this.signature = '';
    this.imageUrl = '';
  }

  isCanvasBlank(canvas: any) {
    const context = canvas;
    const pixelBuffer = new Uint32Array(
      context.getImageData(0, 0, 550, 240).data.buffer
    );
  
     return (!pixelBuffer.some(color => color !== 0));
  }

  getFile(pad: NgxSignaturePadComponent) {
    this.fileupload(pad.getSignatureFile());
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if(event.target.innerWidth > 768){
      this.isSignatureNotAdded = this.isCanvasBlank(this.signaturePad.ctx)
    }
    else{
      this.isSignatureNotAdded = this.isCanvasBlank(this.signaturePad2.ctx)
    }
  }
}
